import { Col } from "react-bootstrap";
import Filter, {
  FilterMultiSelect,
  FilterText,
} from "../../components/Filter/Filter.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import { RoleEntity } from "../../Entities/RoleEntity.tsx";
import { LinkButton, VARIANTS } from "../../components/Button/Button.tsx";
import { URLS } from "../../../commun/routes.tsx";
import { IconAddUser, IconAddUsers } from "../../components/Icon/Icon.tsx";

type filtreUtilisateur = {
  utilisateurUsername?: string;
  roles?: RoleEntity[];
  rolesIds?: string[];
};

export const initialFilterValues = {
  utilisateurUsername: "",
  rolesIds: null,
};

export const filterValuesToVariable = ({
  utilisateurUsername,
  roles,
}: filtreUtilisateur) => {
  const filter: filtreUtilisateur = {};

  if (utilisateurUsername != null && utilisateurUsername.trim() !== "") {
    filter.utilisateurUsername = utilisateurUsername;
  }

  if (roles != null && roles.length > 0) {
    filter.rolesIds = roles.map((e: RoleEntity) => e.roleId);
  }
  return filter;
};

const FilterUtilisateurs = () => {
  const stateListRole = useGet(url`/api/roles/`);

  return (
    <Filter
      right={
        <>
          <Col className={"my-auto"}>
            <LinkButton
              href={URLS.CREATE_ROLE_UTILISATEUR}
              variant={VARIANTS.secondary}
              className={"text-nowrap"}
            >
              <IconAddUser /> Ajouter un utilisateur
            </LinkButton>
          </Col>
          <Col className={"my-auto"}>
            <LinkButton
              href={URLS.IMPORT_UTILISATEUR}
              variant={VARIANTS.secondary}
              className={"text-nowrap"}
            >
              <IconAddUsers /> Importer des utilisateurs
            </LinkButton>
          </Col>
        </>
      }
    >
      <>
        <Col className={"my-auto"}>
          <FilterText
            label=""
            aria-labelledby="recherche-utilisateur"
            placeholder="Recherche un utilisateur"
            name="utilisateurUsername"
          />
          <p id="recherche-utilisateur" className={"d-none"}>
            Rechercher un utilisateur
          </p>
        </Col>
        <Col className={"my-auto"}>
          <FilterMultiSelect
            label=""
            aria-labelledby="filtrer-roles"
            name="roles"
            placeholder="Filtrer par rôles"
            options={stateListRole.value}
            getOptionValue={(r: RoleEntity) => r.roleId}
            toOptionLabelFunc={(r: RoleEntity) => r.roleLibelle}
            isClearable
          />
          <p id="filtrer-roles" className={"d-none"}>
            Filtrer par rôles
          </p>
        </Col>
      </>
    </Filter>
  );
};

export default FilterUtilisateurs;
